import React from 'react'

import {S1, Icon, Badge} from '../../src/components/UI/index.js'

// The option icons of a stop (or the summed options of a bundle) and its number of colli
export function OptionIcons({options, colliCount, color, style = {}}) {
    const iconStyle = {fontSize: 20, marginRight: 6, color}

    return (
        <div style={{display: 'flex', alignItems: 'center', overflow: 'hidden', ...style}}>
            {colliCount > 1 && colliCount < 10 &&
                <Icon style={iconStyle} icon={`mdi mdi-numeric-${colliCount}-circle`} />
            }
            {colliCount >= 10 &&
                <Icon style={iconStyle} icon='mdi mdi-numeric-9-plus-circle' />
            }
            {options.gpsRequired &&
                <Icon style={iconStyle} icon='mdi mdi-map-marker' />
            }
            {options.signatureRequired &&
                <Icon style={iconStyle} icon='mdi mdi-fountain-pen-tip' />
            }
            {options.nameRequired && !options.signatureRequired &&
                <Icon style={iconStyle} icon='mdi mdi-signature-text' />
            }
            {options.signatureNeighbors &&
                <Icon style={iconStyle} icon='mdi mdi-home-edit-outline' />
            }
            {options.statedAddressOnly &&
                <Icon style={iconStyle} icon='mdi mdi-home-alert' />
            }
            {options.mailboxDelivery &&
                <Icon style={iconStyle} icon='mdi mdi-mailbox-open-up' />
            }
            {options.refrigerated &&
                <Icon style={iconStyle} icon='mdi mdi-snowflake' />
            }
            {options.scanRequired &&
                <Icon style={iconStyle} icon='mdi mdi-barcode-scan' />
            }
            {options.imageRequired &&
                <Icon style={iconStyle} icon='mdi mdi-camera' />
            }
            {options.minimumAge &&
                <S1 style={{color}}>{`${options.minimumAge}+`}</S1>
            }
            {options.idCheck &&
                <Icon style={iconStyle} icon='mdi mdi-card-account-details' />
            }
            {options.verificationCode &&
                <Icon style={iconStyle} icon='mdi mdi-shield-key' />
            }
        </div>
    )
}

export function CustomOptionBadges({reseller, customOptions, style = {}}) {
    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', ...style}}>
            {customOptions?.length > 0 && customOptions.map((optionId) => {
                const option = reseller.settings.orders.customOptions?.find((option) => option.id === optionId)

                if (!option) {
                    return null
                }

                return (
                    <Badge key={optionId} color={option.color}>
                        {option.name}
                    </Badge>
                )
            })}
        </div>
    )
}
